/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import {
  EntraIdShiftMappingRequest,
  EntraIdJobPositionMappingRequest,
  EntraIdDepartmentMappingRequest,
} from '../models/entra-id-mapping.model';

export class LoadEntraIdDepartmentMappings {
  static readonly type = '[EntraIdDepartmentMapping] Load Mappings';
  constructor(public filter?: MainTableFilterModel) {}
}

export class CreateEntraIdDepartmentMapping {
  static readonly type = '[EntraIdDepartmentMapping] Create Mapping';
  constructor(
    public tenantId: string,
    public mapping: EntraIdDepartmentMappingRequest
  ) {}
}

export class UpdateEntraIdDepartmentMapping {
  static readonly type = '[EntraIdDepartmentMapping] Update Mapping';
  constructor(
    public tenantId: string,
    public mappingId: string,
    public mapping: EntraIdDepartmentMappingRequest
  ) {}
}

export class DeleteEntraIdDepartmentMapping {
  static readonly type = '[EntraIdDepartmentMapping] Delete Mapping';
  constructor(
    public tenantId: string,
    public mappingId: string
  ) {}
}

export class LoadEntraIdJobPositionMappings {
  static readonly type = '[EntraIdJobPositionMapping] Load Mappings';
  constructor(public filter?: MainTableFilterModel) {}
}

export class CreateEntraIdJobPositionMapping {
  static readonly type = '[EntraIdJobPositionMapping] Create Mapping';
  constructor(
    public tenantId: string,
    public mapping: EntraIdJobPositionMappingRequest
  ) {}
}

export class UpdateEntraIdJobPositionMapping {
  static readonly type = '[EntraIdJobPositionMapping] Update Mapping';
  constructor(
    public tenantId: string,
    public mappingId: string,
    public mapping: EntraIdJobPositionMappingRequest
  ) {}
}

export class DeleteEntraIdJobPositionMapping {
  static readonly type = '[EntraIdJobPositionMapping] Delete Mapping';
  constructor(
    public tenantId: string,
    public mappingId: string
  ) {}
}

export class LoadEntraIdShiftMappings {
  static readonly type = '[EntraIdShiftMapping] Load Mappings';
  constructor(public filter?: MainTableFilterModel) {}
}

export class CreateEntraIdShiftMapping {
  static readonly type = '[EntraIdShiftMapping] Create Mapping';
  constructor(
    public tenantId: string,
    public mapping: EntraIdShiftMappingRequest
  ) {}
}

export class UpdateEntraIdShiftMapping {
  static readonly type = '[EntraIdShiftMapping] Update Mapping';
  constructor(
    public tenantId: string,
    public mappingId: string,
    public mapping: EntraIdShiftMappingRequest
  ) {}
}

export class DeleteEntraIdShiftMapping {
  static readonly type = '[EntraIdShiftMapping] Delete Mapping';
  constructor(
    public tenantId: string,
    public mappingId: string
  ) {}
}
